export const EXTENSIONES_DOCUMENTOS = ['pdf'];

export const MIMETYPE_PDF = 'application/pdf';

export const FILE_TYPE_MAP: Record<string, string> = {
	// Documentos
	[MIMETYPE_PDF]: 'pdf',
	'application/msword': 'doc',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
	'application/vnd.ms-excel': 'xls',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	'application/vnd.ms-powerpoint': 'ppt',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',

	// Imágenes
	'image/jpeg': 'jpeg',
	'image/jpg': 'jpg',
	'image/png': 'png',
	'image/gif': 'gif',
	'image/webp': 'webp',
	'image/bmp': 'bmp',
	'image/tiff': 'tiff',

	// Comprimidos
	'application/zip': 'zip',
	'application/x-rar-compressed': 'rar',
	'application/x-7z-compressed': '7z',
};

export const MESSAGE_PREVIEW_FILE =
	'Solo se pueden previsualizar los archivos PDF; los otros tipos de ficheros, Word, Excel y GML, solo se pueden descargar.';
